<template>
  <div class="page-editor">
    <v-form ref="pageDialogForm">
      <v-text-field label="Angezeigter übertitel im Anamnesebogen" filled v-model="formData.displayedTitle"></v-text-field>
      <draggable v-model="formData.questions">
        <v-card dark class="question-card" :key="'addedQuestion' + question._id" v-for="(question, index) in formData.questions">
          <v-btn
            absolute
            top
            right
            icon
            color="red"
            @click="formData.questions = formData.questions.filter((origQuestion) => origQuestion._id !== question._id)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-title class="font-weight-bold">Frage {{ index + 1 }}</v-card-title>
          <v-card-title>{{ question.title }}</v-card-title>
          <v-divider></v-divider>
        </v-card>
      </draggable>
      <div>
        <v-menu v-model="addQuestionMenu" :close-on-content-click="false" dark offset-y absolute>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="addNewQuestion ma-auto">
              <v-card-title class="font-weight-bold text-center">Neue Frage Hinzufügen</v-card-title>
            </div>
          </template>
          <v-card dark>
            <v-card-title>Frage auswählen</v-card-title>
            <v-divider></v-divider>
            <v-list dark style="max-height: 60vh">
              <v-list-item
                v-for="question in questions.filter((question) => !formData.questions.find((origQuestion) => origQuestion._id === question._id))"
                class="dark"
                :key="question._id"
                @click="addQuestion(question)">
                <v-list-item-title>{{ question.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
      <v-switch label="Im Express Anamnesebogen anzeigen" color="primary" inset v-model="formData.showInExpress"></v-switch>
    </v-form>
    <v-card-actions class="justify-content-center">
      <v-btn class="ma-auto" v-if="formData._id" @click="deletePage()" color="red">löschen</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import api from "@/api"
import draggable from "vuedraggable"

export default {
  components: {
    draggable,
  },
  props: {
    studio: {
      type: String,
      required: true,
    },
    page: {
      type: Object,
      required: false,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      addQuestionMenu: false,
      rules: [(v) => !!v || "Dieses Feld ist ein Pflichtfeld"],

      formData: {
        title: "",
        displayedTitle: "",
        questions: [],
        showInExpress: true,
      },
    }
  },
  created() {
    console.log(this.page)
    if (this.page && this.page._id) {
      this.formData = JSON.parse(JSON.stringify(this.page))
      console.log(this.page)
    } else {
      this.formData = {
        displayedTitle: "",
        title: "",
        questions: [],
        showInExpress: true,
      }
    }
  },
  methods: {
    addQuestion(question) {
      this.formData.questions.push(question)
      this.addQuestionMenu = false
    },
    async createPage() {
      if (this.$refs.pageDialogForm.validate()) {
        if (!this.formData.questions.length) {
          alert("Bitte mindestens eine Frage hinzufügen")
          return
        }
        if (this.studio === "nutrition") {
          this.formData.nutrition = true
        } else if (this.studio === "employeeQuestionnaire") {
          this.formData.employeeQuestionnaire = true
        } else if (this.studio === "livestyleAnamnese") {
          this.formData.livestyleAnamnese = true
        } else {
          this.formData.studio = this.studio
        }
        let createdPage = await api.createOrUpdateAnamnesePage(this.formData)
        this.$emit("saveFinished", createdPage)
      }
    },
    async deletePage() {
      if (confirm("Seite wirklich löschen?")) {
        await api.deleteAnamnesePage({ _id: this.page._id })
        this.$emit("deleted")
      }
    },
  },
}
</script>
<style scoped>
.page-editor {
  color: #f4f4f5;
  font-size: 1rem;
}

.question-card {
  margin-bottom: 0.625rem;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.875rem !important;
  background: rgba(255, 255, 255, 0.035) !important;
  box-shadow: none !important;
}

.addNewQuestion {
  width: 100%;
  padding: 1rem;
  border: 1px dashed rgba(88, 211, 136, 0.5);
  border-radius: 0.875rem;
  color: #a6edc0;
  background: rgba(0, 150, 64, 0.055);
  cursor: pointer;
}

.page-editor ::v-deep .v-input__slot {
  border-color: rgba(255, 255, 255, 0.12) !important;
  background: rgba(255, 255, 255, 0.035) !important;
}
</style>
